import { render } from "./SurveyTestAgain.vue?vue&type=template&id=31559e66&scoped=true"
import script from "./SurveyTestAgain.vue?vue&type=script&lang=js"
export * from "./SurveyTestAgain.vue?vue&type=script&lang=js"

import "./SurveyTestAgain.vue?vue&type=style&index=0&id=31559e66&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31559e66"]])

export default __exports__